import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'successfully-sumbit-for-legalization',
  templateUrl: './successfully-sumbit-for-legalization.component.html',
  styleUrls: ['./successfully-sumbit-for-legalization.component.scss'],
  standalone: false
})
export class SuccessfullySumbitForLegalizationComponent {
  private route = inject(ActivatedRoute);

  workerId: number;
  constructor() { }

  ngOnInit(): void {
    this.workerId = this.route.snapshot.params.id;
  }
}